export function labelRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_LABEL_START":           
        case "FETCH_LABELS_START":                                 
        case "UPDATE_LABEL_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_LABEL_FULFILLED":           
        case "FETCH_LABELS_FULFILLED":                                 
        case "UPDATE_LABEL_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_LABEL_ERROR":
        case "FETCH_LABELS_ERROR":
        case "UPDATE_LABEL_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}